export default __webpack_public_path__ + "static/media/graphbtn.05a49ad0.svg";